import React, { useState, useEffect } from "react";
import "./Usuarios.css";

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    nombre: "",
    email: "",
    rol: "trabajador",
    password: "",
    porcentaje_comision: 5.00 // Valor por defecto del 5%
  });
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      const response = await fetch('https://backend-vbfh.onrender.com/api/usuarios');
      const data = await response.json();
      setUsuarios(data);
    } catch (error) {
      console.error("Error fetching usuarios:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "porcentaje_comision" ? parseFloat(value) || 0 : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Preparar los datos a enviar
    const usuarioData = {
      nombre: formData.nombre,
      email: formData.email,
      rol: formData.rol,
      porcentaje_comision: parseFloat(formData.porcentaje_comision) || 5.00
    };

    // Solo incluir la contraseña si no estamos editando o si se proporcionó una nueva
    if (!editing || formData.password) {
      usuarioData.password = formData.password;
    }

    const method = editing ? 'PUT' : 'POST';
    const url = editing 
      ? `https://backend-vbfh.onrender.com/api/usuarios/${formData.id}` 
      : 'https://backend-vbfh.onrender.com/api/usuarios';

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(usuarioData),
      });

      if (response.ok) {
        fetchUsuarios();
        setFormData({ 
          id: null, 
          nombre: "", 
          email: "", 
          rol: "trabajador", 
          password: "",
          porcentaje_comision: 5.00 
        });
        setEditing(false);
      } else {
        const errorData = await response.json();
        console.error("Error al guardar usuario:", errorData);
        alert(`Error: ${errorData.error || 'Error desconocido'}`);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      alert("Error al conectar con el servidor");
    }
  };

  const handleEdit = (usuario) => {
    setFormData({ 
      ...usuario, 
      password: "", // Se limpia la contraseña al editar
      porcentaje_comision: usuario.porcentaje_comision || 5.00 
    });
    setEditing(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;
    
    try {
      const response = await fetch(`https://backend-vbfh.onrender.com/api/usuarios/${id}`, {
        method: 'DELETE',
      });
      
      if (response.ok) {
        fetchUsuarios();
      } else {
        const errorData = await response.json();
        console.error("Error al eliminar usuario:", errorData);
        alert(`Error: ${errorData.error || 'Error desconocido'}`);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      alert("Error al conectar con el servidor");
    }
  };

  return (
    <div className="usuarios-container">
      <h1>Administración de Usuarios</h1>
      <form onSubmit={handleSubmit} className="usuario-form">
        <h2>{editing ? "Editar Usuario" : "Crear Usuario"}</h2>
        <div className="form-group">
          <label>Nombre:</label>
          <input
            type="text"
            name="nombre"
            placeholder="Nombre completo"
            value={formData.nombre}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            placeholder="Correo electrónico"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Contraseña:</label>
          <input
            type="password"
            name="password"
            placeholder={editing ? "Nueva contraseña (dejar en blanco para no cambiar)" : "Contraseña"}
            value={formData.password}
            onChange={handleInputChange}
            required={!editing}
          />
        </div>
        
        <div className="form-group">
          <label>Rol:</label>
          <select 
            name="rol" 
            value={formData.rol} 
            onChange={handleInputChange} 
            required
          >
            <option value="admin">Administrador</option>
            <option value="trabajador">Trabajador</option>
          </select>
        </div>
        
        {formData.rol === "trabajador" && (
          <div className="form-group">
            <label>Porcentaje de Comisión (%):</label>
            <input
              type="number"
              name="porcentaje_comision"
              min="0"
              max="100"
              step="0.01"
              value={formData.porcentaje_comision}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        
        <div className="form-actions">
          <button type="submit" className="boton-guardar">
            {editing ? "Actualizar Usuario" : "Crear Usuario"}
          </button>
          {editing && (
            <button
              type="button"
              className="boton-cancelar"
              onClick={() => {
                setFormData({ 
                  id: null, 
                  nombre: "", 
                  email: "", 
                  rol: "trabajador", 
                  password: "",
                  porcentaje_comision: 5.00 
                });
                setEditing(false);
              }}
            >
              Cancelar Edición
            </button>
          )}
        </div>
      </form>
      
      <div className="lista-usuarios">
        <h2>Lista de Usuarios</h2>
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Comisión</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((usuario) => (
              <tr key={usuario.id}>
                <td>{usuario.nombre}</td>
                <td>{usuario.email}</td>
                <td>{usuario.rol}</td>
                <td>
                  {usuario.rol === "trabajador" 
                    ? `${usuario.porcentaje_comision || 5}%` 
                    : "N/A"}
                </td>
                <td className="acciones">
                  <button
                    className="boton-editar"
                    onClick={() => handleEdit(usuario)}
                  >
                    Editar
                  </button>
                  <button
                    className="boton-eliminar"
                    onClick={() => handleDelete(usuario.id)}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Usuarios;